import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 44 }} spin />;

const Spinner = () => {
  return (
    <div className="spin-wrapper">
      <Spin indicator={antIcon} />
    </div>
  );
};

export default Spinner;
